import script from "./MediaList.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaList.vue?vue&type=script&setup=true&lang=ts"

import "./MediaList.vue?vue&type=style&index=0&id=21b8e4af&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b8e4af"]])

export default __exports__